import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavTabService } from '@app/core/navTab.service';
import { KycService } from '@app/core/kyc.service';

@Component({
  selector: 'app-nav-tab',
  templateUrl: './nav-tab.template.html'
})

export class NavTabComponent implements OnInit {
  items: any[] = [];
  styles: any = {};
  constructor(
    private router: Router,
    public navTabService: NavTabService,
    private kycService: KycService) {
    this.items = navTabService.navItems;
  }

  ngOnInit(): void {
    this.styles = { color: this.kycService.kycInfo.IconColor }
  }

  onTabClicked(url: string, key: string) {
    let allowToNavigate = true;

    switch (key) {
      case 'coverage':
        allowToNavigate = this.kycService.kyc.profile.completed;
        break;
      case 'submit':
        // already has email
        if (this.kycService.kyc.save.completed) {
          allowToNavigate = false;
          this.navTabService.setActiveTab(key);
          let tenant = this.kycService.getTenant();
          this.router.navigate([tenant, 'journey', 'thank-you']);
          break;
        }

        //if (!this.kycService.kyc.profile.emailInvalid) {
        //  allowToNavigate = false; 
        //}
        allowToNavigate = this.kycService.kyc.profile.completed;
        break;
      default: break;
    }

    if (allowToNavigate) {
      this.navTabService.setActiveTab(key);
      let tenant = this.kycService.getTenant();
      this.router.navigateByUrl(tenant + '/' + url);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/nav-tab/nav-tab.component.ts